export function DeleteIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.6454 3.33449h-2.6322C14.6099 1.39632 12.8693.00694686 10.8527 0H9.15446C7.13785 0 5.40427 1.39632 4.99388 3.33449H2.36167c-.467 0-.8491.37513-.8491.83362 0 .4585.3821.83363.8491.83363h.8491V15.8319c0 2.2994 1.9034 4.1612 4.2455 4.1681h5.08753c2.3421 0 4.2384-1.8687 4.2455-4.1681V4.99479h.8491c.467 0 .8491-.37513.8491-.83362 0-.4585-.3821-.83363-.8491-.83363l.007.00695ZM9.16152 1.66725h1.69818c1.0756 0 2.0379.66689 2.3987 1.66724H6.76283C7.1237 2.33414 8.086 1.66725 9.16152 1.66725ZM15.0981 15.8249c0 1.3825-1.1392 2.5009-2.5473 2.5009H7.46333c-1.40809 0-2.5473-1.1184-2.5473-2.5009V4.99479H15.0981V15.8249Z"
      />
      <path
        fill="currentColor"
        d="M8.31244 14.9913c.467 0 .84908-.3751.84908-.8336V9.1629c0-.45849-.38208-.83362-.84908-.83362-.46701 0-.84911.37513-.84911.83362v4.9948c0 .4585.3821.8336.84911.8336ZM11.7018 14.9913c.467 0 .849-.3751.849-.8336V9.1629c0-.45849-.382-.83362-.849-.83362-.467 0-.8491.37513-.8491.83362v4.9948c0 .4585.3821.8336.8491.8336Z"
      />
    </svg>
  );
}
